import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip, Typography } from '@mui/material';
import { Call } from '../../../model/calls/types';
import { formatRelativeDate, formatSecondsToMMSS, getSecondsBehind } from './helper';

const A_SECOND_IN_MS = 1000;

export const CallDateAndStatus = ({ started_at, ended_at }: Call['call']) => {
  const { t } = useTranslation();

  if (ended_at)
    return (
      <Typography variant="caption" color="textPrimary">
        {formatRelativeDate(started_at ?? ended_at)}
      </Typography>
    );

  if (started_at) return <CallIsGoing started_at={started_at} />;

  return <Chip label={t('AwaitingResponse')} color="warning" size="small" />;
};

const CallIsGoing = ({ started_at }: { started_at: string }) => {
  const [secondsBehind, setSecondsBehind] = useState(0);

  useEffect(() => {
    setSecondsBehind(getSecondsBehind(started_at));

    const timeInterval = setInterval(() => {
      setSecondsBehind((prev) => prev + 1);
    }, A_SECOND_IN_MS);

    return () => {
      clearInterval(timeInterval);
    };
  }, []);

  return <Chip label={formatSecondsToMMSS(secondsBehind)} color="primary" size="small" />;
};
